import { SVGIcon } from '@progress/kendo-svg-icons';

// Kendo's chartScatter with the markers mirrored about the plot centre (y -> 448 - y), so the
// points rise left to right. Same axis, same four marker positions, same visual weight.
export const chartScatterUpIcon: SVGIcon = {
    name: 'chart-scatter-up',
    viewBox: '0 0 512 512',
    content:
        '<path d="M480 448v32H32V32h32v416z' +
        'M160 352c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32m-16 0c0-8.8-7.2-16-16-16s-16 7.2-16 16 7.2 16 16 16 16-7.2 16-16' +
        'M256 160c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32m-16 0c0-8.8-7.2-16-16-16s-16 7.2-16 16 7.2 16 16 16 16-7.2 16-16' +
        'M352 288c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32m-16 0c0-8.8-7.2-16-16-16s-16 7.2-16 16 7.2 16 16 16 16-7.2 16-16' +
        'M448 96c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32m-16 0c0-8.8-7.2-16-16-16s-16 7.2-16 16 7.2 16 16 16 16-7.2 16-16" />',
};

// Kendo has no lightbulb. Drawn on its 512 grid to sit level with the icons beside it: a filled
// dome over two contacts, with the gaps kept wide because at the 16px these render at, anything
// finer closes up into a blob.
export const lightbulbIcon: SVGIcon = {
    name: 'lightbulb',
    viewBox: '0 0 512 512',
    content:
        '<path d="M256 56C181 56 120 117 120 192c0 45 22 78 44 104 13 15 20 27 22 40h140' +
        'c2-13 9-25 22-40 22-26 44-59 44-104 0-75-61-136-136-136z" />' +
        '<path d="M196 376h120v36H196z" />' +
        '<path d="M216 436h80c0 22-18 40-40 40s-40-18-40-40z" />',
};
